// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.jsdelivr.net/npm/keen-slider@6.8.6/+esm'

const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class QuotesCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  disconnectedCallback () {
    this.destroyCarousel()
  }

  destroyCarousel () {
    if (this.carousel && typeof this.carousel.destroy === 'function') {
      this.carousel.destroy()
      this.carousel = null
    }
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        slides: {
          perView: 1,
          spacing: 0,
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

customElements.define('quotes-carousel', QuotesCarousel)
